import { Button, Flex, Image, Stack, Text } from '@chakra-ui/react'
import ScheduleIcon from '@/assets/icons/schedule.svg';

type Props = {
  onButtonClick: () => void
}

const EmptyAgendas = ({ onButtonClick }: Props) => (
  <Stack align="center" gap="4">
    <Flex justify="center">
      <Flex
        width="100px"
        height="100px"
        borderRadius="full"
        backgroundColor="primary.50"
        alignItems="center"
        justifyContent="center"
      >
        <Image src={ScheduleIcon} alt="Agenda" width="50px" height="50px" />
      </Flex>
    </Flex>
    <Text textStyle="lg" color="fg.muted" textAlign="center">
      Você não possui nenhuma agenda.
      <br />
      Deseja criar uma agora?
    </Text>
    <Button size="sm" colorPalette="primary" onClick={onButtonClick}>
      Criar agenda
    </Button>
  </Stack>
);

export default EmptyAgendas
